/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccessToken,
  Courier,
  CourierPackage,
  CourierSettings,
  CourierUser,
  Invoice,
  MailOption,
  Mailbox,
  NewCourierPackage,
  NewCourierUser,
  NewInvoice,
  NewMailbox,
  NewRewardsAccount,
  NewRewardsClaim,
  NewRole,
  NewRoleMapping,
  RewardPrize,
  RewardSettings,
  RewardsAccount,
  RewardsClaim,
  RewardsClaimClaimRewardRequest,
  Role,
  RoleMapping,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
} from '../models/index';
import {
    AccessTokenFromJSON,
    AccessTokenToJSON,
    CourierFromJSON,
    CourierToJSON,
    CourierPackageFromJSON,
    CourierPackageToJSON,
    CourierSettingsFromJSON,
    CourierSettingsToJSON,
    CourierUserFromJSON,
    CourierUserToJSON,
    InvoiceFromJSON,
    InvoiceToJSON,
    MailOptionFromJSON,
    MailOptionToJSON,
    MailboxFromJSON,
    MailboxToJSON,
    NewCourierPackageFromJSON,
    NewCourierPackageToJSON,
    NewCourierUserFromJSON,
    NewCourierUserToJSON,
    NewInvoiceFromJSON,
    NewInvoiceToJSON,
    NewMailboxFromJSON,
    NewMailboxToJSON,
    NewRewardsAccountFromJSON,
    NewRewardsAccountToJSON,
    NewRewardsClaimFromJSON,
    NewRewardsClaimToJSON,
    NewRoleFromJSON,
    NewRoleToJSON,
    NewRoleMappingFromJSON,
    NewRoleMappingToJSON,
    RewardPrizeFromJSON,
    RewardPrizeToJSON,
    RewardSettingsFromJSON,
    RewardSettingsToJSON,
    RewardsAccountFromJSON,
    RewardsAccountToJSON,
    RewardsClaimFromJSON,
    RewardsClaimToJSON,
    RewardsClaimClaimRewardRequestFromJSON,
    RewardsClaimClaimRewardRequestToJSON,
    RoleFromJSON,
    RoleToJSON,
    RoleMappingFromJSON,
    RoleMappingToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
} from '../models/index';

export interface RewardsClaimClaimRewardOperationRequest {
    rewardsClaimClaimRewardRequest?: RewardsClaimClaimRewardRequest;
}

export interface RewardsClaimCountRequest {
    where?: string;
}

export interface RewardsClaimCreateRequest {
    data?: NewRewardsClaim;
}

export interface RewardsClaimCreateChangeStreamGetRewardsClaimsChangeStreamRequest {
    options?: string;
}

export interface RewardsClaimCreateChangeStreamPostRewardsClaimsChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface RewardsClaimDeleteByIdRequest {
    id: string;
}

export interface RewardsClaimExistsGetRewardsClaimsidExistsRequest {
    id: string;
}

export interface RewardsClaimExistsHeadRewardsClaimsidRequest {
    id: string;
}

export interface RewardsClaimFindRequest {
    filter?: string;
}

export interface RewardsClaimFindByIdRequest {
    id: string;
    filter?: string;
}

export interface RewardsClaimFindOneRequest {
    filter?: string;
}

export interface RewardsClaimPatchOrCreateRequest {
    data?: RewardsClaim;
}

export interface RewardsClaimPrototypeCountCourierRewardsAccountsRequest {
    id: string;
    where?: string;
}

export interface RewardsClaimPrototypeCountCourierUserAccessTokensRequest {
    id: string;
    where?: string;
}

export interface RewardsClaimPrototypeCountCourierUserCourierPackagesRequest {
    id: string;
    where?: string;
}

export interface RewardsClaimPrototypeCountCourierUserInvoicesRequest {
    id: string;
    where?: string;
}

export interface RewardsClaimPrototypeCountCourierUserMailboxesRequest {
    id: string;
    where?: string;
}

export interface RewardsClaimPrototypeCountCourierUserReferrerRequest {
    id: string;
    where?: string;
}

export interface RewardsClaimPrototypeCountCourierUserRoleMappingsRequest {
    id: string;
    where?: string;
}

export interface RewardsClaimPrototypeCountCourierUserRolesRequest {
    id: string;
    where?: string;
}

export interface RewardsClaimPrototypeCreateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface RewardsClaimPrototypeCreateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface RewardsClaimPrototypeCreateCourierRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface RewardsClaimPrototypeCreateCourierRewardsAccountsRequest {
    id: string;
    data?: NewRewardsAccount;
}

export interface RewardsClaimPrototypeCreateCourierUserAccessTokensRequest {
    id: string;
    data?: AccessToken;
}

export interface RewardsClaimPrototypeCreateCourierUserCourierPackagesRequest {
    id: string;
    data?: NewCourierPackage;
}

export interface RewardsClaimPrototypeCreateCourierUserInvoicesRequest {
    id: string;
    data?: NewInvoice;
}

export interface RewardsClaimPrototypeCreateCourierUserMailboxesRequest {
    id: string;
    data?: NewMailbox;
}

export interface RewardsClaimPrototypeCreateCourierUserReferrerRequest {
    id: string;
    data?: NewCourierUser;
}

export interface RewardsClaimPrototypeCreateCourierUserRewardsAccountRequest {
    id: string;
    data?: RewardsAccount;
}

export interface RewardsClaimPrototypeCreateCourierUserRoleMappingsRequest {
    id: string;
    data?: NewRoleMapping;
}

export interface RewardsClaimPrototypeCreateCourierUserRolesRequest {
    id: string;
    data?: NewRole;
}

export interface RewardsClaimPrototypeDeleteCourierRewardsAccountsRequest {
    id: string;
}

export interface RewardsClaimPrototypeDeleteCourierUserAccessTokensRequest {
    id: string;
}

export interface RewardsClaimPrototypeDeleteCourierUserCourierPackagesRequest {
    id: string;
}

export interface RewardsClaimPrototypeDeleteCourierUserInvoicesRequest {
    id: string;
}

export interface RewardsClaimPrototypeDeleteCourierUserMailboxesRequest {
    id: string;
}

export interface RewardsClaimPrototypeDeleteCourierUserReferrerRequest {
    id: string;
}

export interface RewardsClaimPrototypeDeleteCourierUserRoleMappingsRequest {
    id: string;
}

export interface RewardsClaimPrototypeDeleteCourierUserRolesRequest {
    id: string;
}

export interface RewardsClaimPrototypeDestroyByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeDestroyByIdCourierUserAccessTokensRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeDestroyByIdCourierUserCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeDestroyByIdCourierUserInvoicesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeDestroyByIdCourierUserMailboxesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeDestroyByIdCourierUserReferrerRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeDestroyByIdCourierUserRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeDestroyByIdCourierUserRolesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeDestroyCourierCourierSettingRequest {
    id: string;
}

export interface RewardsClaimPrototypeDestroyCourierMailOptionRequest {
    id: string;
}

export interface RewardsClaimPrototypeDestroyCourierRewardSettingRequest {
    id: string;
}

export interface RewardsClaimPrototypeDestroyCourierUserRewardsAccountRequest {
    id: string;
}

export interface RewardsClaimPrototypeExistsCourierUserRolesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeFindByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeFindByIdCourierUserAccessTokensRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeFindByIdCourierUserCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeFindByIdCourierUserInvoicesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeFindByIdCourierUserMailboxesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeFindByIdCourierUserReferrerRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeFindByIdCourierUserRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeFindByIdCourierUserRolesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardsClaimPrototypeGetCourierCourierSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardsClaimPrototypeGetCourierMailOptionRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardsClaimPrototypeGetCourierRewardSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardsClaimPrototypeGetCourierRewardsAccountsRequest {
    id: string;
    filter?: string;
}

export interface RewardsClaimPrototypeGetCourierUserRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardsClaimPrototypeGetCourierUserAccessTokensRequest {
    id: string;
    filter?: string;
}

export interface RewardsClaimPrototypeGetCourierUserCourierPackagesRequest {
    id: string;
    filter?: string;
}

export interface RewardsClaimPrototypeGetCourierUserInvoicesRequest {
    id: string;
    filter?: string;
}

export interface RewardsClaimPrototypeGetCourierUserMailboxesRequest {
    id: string;
    filter?: string;
}

export interface RewardsClaimPrototypeGetCourierUserReferrerRequest {
    id: string;
    filter?: string;
}

export interface RewardsClaimPrototypeGetCourierUserRewardsAccountRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardsClaimPrototypeGetCourierUserRoleMappingsRequest {
    id: string;
    filter?: string;
}

export interface RewardsClaimPrototypeGetCourierUserRolesRequest {
    id: string;
    filter?: string;
}

export interface RewardsClaimPrototypeGetRewardPrizeRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardsClaimPrototypeGetRewardPrizeCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardsClaimPrototypeLinkCourierUserRolesRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface RewardsClaimPrototypePatchAttributesRequest {
    id: string;
    data?: RewardsClaim;
}

export interface RewardsClaimPrototypeUnlinkCourierUserRolesRequest {
    id: string;
    fk: string;
}

export interface RewardsClaimPrototypeUpdateByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
    data?: RewardsAccount;
}

export interface RewardsClaimPrototypeUpdateByIdCourierUserAccessTokensRequest {
    id: string;
    fk: string;
    data?: AccessToken;
}

export interface RewardsClaimPrototypeUpdateByIdCourierUserCourierPackagesRequest {
    id: string;
    fk: string;
    data?: CourierPackage;
}

export interface RewardsClaimPrototypeUpdateByIdCourierUserInvoicesRequest {
    id: string;
    fk: string;
    data?: Invoice;
}

export interface RewardsClaimPrototypeUpdateByIdCourierUserMailboxesRequest {
    id: string;
    fk: string;
    data?: Mailbox;
}

export interface RewardsClaimPrototypeUpdateByIdCourierUserReferrerRequest {
    id: string;
    fk: string;
    data?: CourierUser;
}

export interface RewardsClaimPrototypeUpdateByIdCourierUserRoleMappingsRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface RewardsClaimPrototypeUpdateByIdCourierUserRolesRequest {
    id: string;
    fk: string;
    data?: Role;
}

export interface RewardsClaimPrototypeUpdateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface RewardsClaimPrototypeUpdateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface RewardsClaimPrototypeUpdateCourierRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface RewardsClaimPrototypeUpdateCourierUserRewardsAccountRequest {
    id: string;
    data?: RewardsAccount;
}

export interface RewardsClaimReplaceByIdPostRewardsClaimsidReplaceRequest {
    id: string;
    data?: RewardsClaim;
}

export interface RewardsClaimReplaceByIdPutRewardsClaimsidRequest {
    id: string;
    data?: RewardsClaim;
}

export interface RewardsClaimReplaceOrCreatePostRewardsClaimsReplaceOrCreateRequest {
    data?: RewardsClaim;
}

export interface RewardsClaimReplaceOrCreatePutRewardsClaimsRequest {
    data?: RewardsClaim;
}

export interface RewardsClaimUpdateAllRequest {
    where?: string;
    data?: RewardsClaim;
}

export interface RewardsClaimUpsertWithWhereRequest {
    where?: string;
    data?: RewardsClaim;
}

/**
 * 
 */
export class RewardsClaimApi extends runtime.BaseAPI {

    /**
     */
    async rewardsClaimClaimRewardRaw(requestParameters: RewardsClaimClaimRewardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/claimReward`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsClaimClaimRewardRequestToJSON(requestParameters['rewardsClaimClaimRewardRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async rewardsClaimClaimReward(requestParameters: RewardsClaimClaimRewardOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.rewardsClaimClaimRewardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async rewardsClaimCountRaw(requestParameters: RewardsClaimCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async rewardsClaimCount(requestParameters: RewardsClaimCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardsClaimCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async rewardsClaimCreateRaw(requestParameters: RewardsClaimCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRewardsClaimToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async rewardsClaimCreate(requestParameters: RewardsClaimCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async rewardsClaimCreateChangeStreamGetRewardsClaimsChangeStreamRaw(requestParameters: RewardsClaimCreateChangeStreamGetRewardsClaimsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async rewardsClaimCreateChangeStreamGetRewardsClaimsChangeStream(requestParameters: RewardsClaimCreateChangeStreamGetRewardsClaimsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.rewardsClaimCreateChangeStreamGetRewardsClaimsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async rewardsClaimCreateChangeStreamPostRewardsClaimsChangeStreamRaw(requestParameters: RewardsClaimCreateChangeStreamPostRewardsClaimsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async rewardsClaimCreateChangeStreamPostRewardsClaimsChangeStream(requestParameters: RewardsClaimCreateChangeStreamPostRewardsClaimsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.rewardsClaimCreateChangeStreamPostRewardsClaimsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async rewardsClaimDeleteByIdRaw(requestParameters: RewardsClaimDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async rewardsClaimDeleteById(requestParameters: RewardsClaimDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.rewardsClaimDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async rewardsClaimExistsGetRewardsClaimsidExistsRaw(requestParameters: RewardsClaimExistsGetRewardsClaimsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimExistsGetRewardsClaimsidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async rewardsClaimExistsGetRewardsClaimsidExists(requestParameters: RewardsClaimExistsGetRewardsClaimsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.rewardsClaimExistsGetRewardsClaimsidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async rewardsClaimExistsHeadRewardsClaimsidRaw(requestParameters: RewardsClaimExistsHeadRewardsClaimsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimExistsHeadRewardsClaimsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async rewardsClaimExistsHeadRewardsClaimsid(requestParameters: RewardsClaimExistsHeadRewardsClaimsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.rewardsClaimExistsHeadRewardsClaimsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async rewardsClaimFindRaw(requestParameters: RewardsClaimFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RewardsClaim>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RewardsClaimFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async rewardsClaimFind(requestParameters: RewardsClaimFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RewardsClaim>> {
        const response = await this.rewardsClaimFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async rewardsClaimFindByIdRaw(requestParameters: RewardsClaimFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async rewardsClaimFindById(requestParameters: RewardsClaimFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async rewardsClaimFindOneRaw(requestParameters: RewardsClaimFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async rewardsClaimFindOne(requestParameters: RewardsClaimFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async rewardsClaimPatchOrCreateRaw(requestParameters: RewardsClaimPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsClaimToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async rewardsClaimPatchOrCreate(requestParameters: RewardsClaimPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async rewardsClaimPrototypeCountCourierRewardsAccountsRaw(requestParameters: RewardsClaimPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCountCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardsAccounts/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async rewardsClaimPrototypeCountCourierRewardsAccounts(requestParameters: RewardsClaimPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardsClaimPrototypeCountCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserAccessTokensRaw(requestParameters: RewardsClaimPrototypeCountCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCountCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/accessTokens/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserAccessTokens(requestParameters: RewardsClaimPrototypeCountCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardsClaimPrototypeCountCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserCourierPackagesRaw(requestParameters: RewardsClaimPrototypeCountCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCountCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/courierPackages/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserCourierPackages(requestParameters: RewardsClaimPrototypeCountCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardsClaimPrototypeCountCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts invoices of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserInvoicesRaw(requestParameters: RewardsClaimPrototypeCountCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCountCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/invoices/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts invoices of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserInvoices(requestParameters: RewardsClaimPrototypeCountCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardsClaimPrototypeCountCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts mailboxes of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserMailboxesRaw(requestParameters: RewardsClaimPrototypeCountCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCountCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/mailboxes/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts mailboxes of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserMailboxes(requestParameters: RewardsClaimPrototypeCountCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardsClaimPrototypeCountCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts referrer of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserReferrerRaw(requestParameters: RewardsClaimPrototypeCountCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCountCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/referrer/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts referrer of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserReferrer(requestParameters: RewardsClaimPrototypeCountCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardsClaimPrototypeCountCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserRoleMappingsRaw(requestParameters: RewardsClaimPrototypeCountCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCountCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roleMappings/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserRoleMappings(requestParameters: RewardsClaimPrototypeCountCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardsClaimPrototypeCountCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roles of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeCountCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCountCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roles of CourierUser.
     */
    async rewardsClaimPrototypeCountCourierUserRoles(requestParameters: RewardsClaimPrototypeCountCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardsClaimPrototypeCountCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async rewardsClaimPrototypeCreateCourierCourierSettingRaw(requestParameters: RewardsClaimPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async rewardsClaimPrototypeCreateCourierCourierSetting(requestParameters: RewardsClaimPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.rewardsClaimPrototypeCreateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async rewardsClaimPrototypeCreateCourierMailOptionRaw(requestParameters: RewardsClaimPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async rewardsClaimPrototypeCreateCourierMailOption(requestParameters: RewardsClaimPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.rewardsClaimPrototypeCreateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async rewardsClaimPrototypeCreateCourierRewardSettingRaw(requestParameters: RewardsClaimPrototypeCreateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async rewardsClaimPrototypeCreateCourierRewardSetting(requestParameters: RewardsClaimPrototypeCreateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.rewardsClaimPrototypeCreateCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async rewardsClaimPrototypeCreateCourierRewardsAccountsRaw(requestParameters: RewardsClaimPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async rewardsClaimPrototypeCreateCourierRewardsAccounts(requestParameters: RewardsClaimPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardsClaimPrototypeCreateCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserAccessTokensRaw(requestParameters: RewardsClaimPrototypeCreateCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserAccessTokens(requestParameters: RewardsClaimPrototypeCreateCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.rewardsClaimPrototypeCreateCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserCourierPackagesRaw(requestParameters: RewardsClaimPrototypeCreateCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserCourierPackages(requestParameters: RewardsClaimPrototypeCreateCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.rewardsClaimPrototypeCreateCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserInvoicesRaw(requestParameters: RewardsClaimPrototypeCreateCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewInvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserInvoices(requestParameters: RewardsClaimPrototypeCreateCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.rewardsClaimPrototypeCreateCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailboxes of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserMailboxesRaw(requestParameters: RewardsClaimPrototypeCreateCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewMailboxToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailboxes of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserMailboxes(requestParameters: RewardsClaimPrototypeCreateCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.rewardsClaimPrototypeCreateCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserReferrerRaw(requestParameters: RewardsClaimPrototypeCreateCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserReferrer(requestParameters: RewardsClaimPrototypeCreateCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.rewardsClaimPrototypeCreateCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardsAccount of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserRewardsAccountRaw(requestParameters: RewardsClaimPrototypeCreateCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierUserRewardsAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/rewardsAccount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardsAccount of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserRewardsAccount(requestParameters: RewardsClaimPrototypeCreateCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardsClaimPrototypeCreateCourierUserRewardsAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserRoleMappingsRaw(requestParameters: RewardsClaimPrototypeCreateCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserRoleMappings(requestParameters: RewardsClaimPrototypeCreateCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.rewardsClaimPrototypeCreateCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeCreateCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeCreateCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async rewardsClaimPrototypeCreateCourierUserRoles(requestParameters: RewardsClaimPrototypeCreateCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.rewardsClaimPrototypeCreateCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async rewardsClaimPrototypeDeleteCourierRewardsAccountsRaw(requestParameters: RewardsClaimPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDeleteCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async rewardsClaimPrototypeDeleteCourierRewardsAccounts(requestParameters: RewardsClaimPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDeleteCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserAccessTokensRaw(requestParameters: RewardsClaimPrototypeDeleteCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDeleteCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserAccessTokens(requestParameters: RewardsClaimPrototypeDeleteCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDeleteCourierUserAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserCourierPackagesRaw(requestParameters: RewardsClaimPrototypeDeleteCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDeleteCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserCourierPackages(requestParameters: RewardsClaimPrototypeDeleteCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDeleteCourierUserCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all invoices of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserInvoicesRaw(requestParameters: RewardsClaimPrototypeDeleteCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDeleteCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all invoices of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserInvoices(requestParameters: RewardsClaimPrototypeDeleteCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDeleteCourierUserInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all mailboxes of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserMailboxesRaw(requestParameters: RewardsClaimPrototypeDeleteCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDeleteCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all mailboxes of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserMailboxes(requestParameters: RewardsClaimPrototypeDeleteCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDeleteCourierUserMailboxesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all referrer of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserReferrerRaw(requestParameters: RewardsClaimPrototypeDeleteCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDeleteCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all referrer of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserReferrer(requestParameters: RewardsClaimPrototypeDeleteCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDeleteCourierUserReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserRoleMappingsRaw(requestParameters: RewardsClaimPrototypeDeleteCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDeleteCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserRoleMappings(requestParameters: RewardsClaimPrototypeDeleteCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDeleteCourierUserRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roles of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeDeleteCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDeleteCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roles of this model.
     */
    async rewardsClaimPrototypeDeleteCourierUserRoles(requestParameters: RewardsClaimPrototypeDeleteCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDeleteCourierUserRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async rewardsClaimPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters: RewardsClaimPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async rewardsClaimPrototypeDestroyByIdCourierRewardsAccounts(requestParameters: RewardsClaimPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserAccessTokensRaw(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserAccessTokens(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyByIdCourierUserAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserCourierPackagesRaw(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserCourierPackages(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyByIdCourierUserCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserInvoicesRaw(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserInvoices(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyByIdCourierUserInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for mailboxes.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserMailboxesRaw(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for mailboxes.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserMailboxes(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyByIdCourierUserMailboxesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserReferrerRaw(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserReferrer(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyByIdCourierUserReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserRoleMappingsRaw(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserRoleMappings(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyByIdCourierUserRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roles.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeDestroyByIdCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roles.
     */
    async rewardsClaimPrototypeDestroyByIdCourierUserRoles(requestParameters: RewardsClaimPrototypeDestroyByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyByIdCourierUserRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async rewardsClaimPrototypeDestroyCourierCourierSettingRaw(requestParameters: RewardsClaimPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async rewardsClaimPrototypeDestroyCourierCourierSetting(requestParameters: RewardsClaimPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyCourierCourierSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes mailOption of this model.
     */
    async rewardsClaimPrototypeDestroyCourierMailOptionRaw(requestParameters: RewardsClaimPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes mailOption of this model.
     */
    async rewardsClaimPrototypeDestroyCourierMailOption(requestParameters: RewardsClaimPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyCourierMailOptionRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async rewardsClaimPrototypeDestroyCourierRewardSettingRaw(requestParameters: RewardsClaimPrototypeDestroyCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async rewardsClaimPrototypeDestroyCourierRewardSetting(requestParameters: RewardsClaimPrototypeDestroyCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyCourierRewardSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes rewardsAccount of this model.
     */
    async rewardsClaimPrototypeDestroyCourierUserRewardsAccountRaw(requestParameters: RewardsClaimPrototypeDestroyCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeDestroyCourierUserRewardsAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/rewardsAccount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes rewardsAccount of this model.
     */
    async rewardsClaimPrototypeDestroyCourierUserRewardsAccount(requestParameters: RewardsClaimPrototypeDestroyCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeDestroyCourierUserRewardsAccountRaw(requestParameters, initOverrides);
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async rewardsClaimPrototypeExistsCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeExistsCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeExistsCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeExistsCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async rewardsClaimPrototypeExistsCourierUserRoles(requestParameters: RewardsClaimPrototypeExistsCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.rewardsClaimPrototypeExistsCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async rewardsClaimPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters: RewardsClaimPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async rewardsClaimPrototypeFindByIdCourierRewardsAccounts(requestParameters: RewardsClaimPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardsClaimPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async rewardsClaimPrototypeFindByIdCourierUserAccessTokensRaw(requestParameters: RewardsClaimPrototypeFindByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async rewardsClaimPrototypeFindByIdCourierUserAccessTokens(requestParameters: RewardsClaimPrototypeFindByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.rewardsClaimPrototypeFindByIdCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async rewardsClaimPrototypeFindByIdCourierUserCourierPackagesRaw(requestParameters: RewardsClaimPrototypeFindByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async rewardsClaimPrototypeFindByIdCourierUserCourierPackages(requestParameters: RewardsClaimPrototypeFindByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.rewardsClaimPrototypeFindByIdCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for invoices.
     */
    async rewardsClaimPrototypeFindByIdCourierUserInvoicesRaw(requestParameters: RewardsClaimPrototypeFindByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for invoices.
     */
    async rewardsClaimPrototypeFindByIdCourierUserInvoices(requestParameters: RewardsClaimPrototypeFindByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.rewardsClaimPrototypeFindByIdCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for mailboxes.
     */
    async rewardsClaimPrototypeFindByIdCourierUserMailboxesRaw(requestParameters: RewardsClaimPrototypeFindByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for mailboxes.
     */
    async rewardsClaimPrototypeFindByIdCourierUserMailboxes(requestParameters: RewardsClaimPrototypeFindByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.rewardsClaimPrototypeFindByIdCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for referrer.
     */
    async rewardsClaimPrototypeFindByIdCourierUserReferrerRaw(requestParameters: RewardsClaimPrototypeFindByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for referrer.
     */
    async rewardsClaimPrototypeFindByIdCourierUserReferrer(requestParameters: RewardsClaimPrototypeFindByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.rewardsClaimPrototypeFindByIdCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async rewardsClaimPrototypeFindByIdCourierUserRoleMappingsRaw(requestParameters: RewardsClaimPrototypeFindByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async rewardsClaimPrototypeFindByIdCourierUserRoleMappings(requestParameters: RewardsClaimPrototypeFindByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.rewardsClaimPrototypeFindByIdCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roles.
     */
    async rewardsClaimPrototypeFindByIdCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeFindByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeFindByIdCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roles.
     */
    async rewardsClaimPrototypeFindByIdCourierUserRoles(requestParameters: RewardsClaimPrototypeFindByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.rewardsClaimPrototypeFindByIdCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async rewardsClaimPrototypeGetCourierRaw(requestParameters: RewardsClaimPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async rewardsClaimPrototypeGetCourier(requestParameters: RewardsClaimPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.rewardsClaimPrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async rewardsClaimPrototypeGetCourierCourierSettingRaw(requestParameters: RewardsClaimPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async rewardsClaimPrototypeGetCourierCourierSetting(requestParameters: RewardsClaimPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.rewardsClaimPrototypeGetCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async rewardsClaimPrototypeGetCourierMailOptionRaw(requestParameters: RewardsClaimPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async rewardsClaimPrototypeGetCourierMailOption(requestParameters: RewardsClaimPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.rewardsClaimPrototypeGetCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async rewardsClaimPrototypeGetCourierRewardSettingRaw(requestParameters: RewardsClaimPrototypeGetCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async rewardsClaimPrototypeGetCourierRewardSetting(requestParameters: RewardsClaimPrototypeGetCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.rewardsClaimPrototypeGetCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async rewardsClaimPrototypeGetCourierRewardsAccountsRaw(requestParameters: RewardsClaimPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RewardsAccount>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RewardsAccountFromJSON));
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async rewardsClaimPrototypeGetCourierRewardsAccounts(requestParameters: RewardsClaimPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RewardsAccount>> {
        const response = await this.rewardsClaimPrototypeGetCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courierUser.
     */
    async rewardsClaimPrototypeGetCourierUserRaw(requestParameters: RewardsClaimPrototypeGetCourierUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courierUser.
     */
    async rewardsClaimPrototypeGetCourierUser(requestParameters: RewardsClaimPrototypeGetCourierUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.rewardsClaimPrototypeGetCourierUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserAccessTokensRaw(requestParameters: RewardsClaimPrototypeGetCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccessToken>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccessTokenFromJSON));
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserAccessTokens(requestParameters: RewardsClaimPrototypeGetCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccessToken>> {
        const response = await this.rewardsClaimPrototypeGetCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserCourierPackagesRaw(requestParameters: RewardsClaimPrototypeGetCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierPackageFromJSON));
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserCourierPackages(requestParameters: RewardsClaimPrototypeGetCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierPackage>> {
        const response = await this.rewardsClaimPrototypeGetCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries invoices of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserInvoicesRaw(requestParameters: RewardsClaimPrototypeGetCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Invoice>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * Queries invoices of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserInvoices(requestParameters: RewardsClaimPrototypeGetCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Invoice>> {
        const response = await this.rewardsClaimPrototypeGetCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries mailboxes of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserMailboxesRaw(requestParameters: RewardsClaimPrototypeGetCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Mailbox>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailboxFromJSON));
    }

    /**
     * Queries mailboxes of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserMailboxes(requestParameters: RewardsClaimPrototypeGetCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Mailbox>> {
        const response = await this.rewardsClaimPrototypeGetCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries referrer of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserReferrerRaw(requestParameters: RewardsClaimPrototypeGetCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierUser>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierUserFromJSON));
    }

    /**
     * Queries referrer of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserReferrer(requestParameters: RewardsClaimPrototypeGetCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierUser>> {
        const response = await this.rewardsClaimPrototypeGetCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation rewardsAccount.
     */
    async rewardsClaimPrototypeGetCourierUserRewardsAccountRaw(requestParameters: RewardsClaimPrototypeGetCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierUserRewardsAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/rewardsAccount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation rewardsAccount.
     */
    async rewardsClaimPrototypeGetCourierUserRewardsAccount(requestParameters: RewardsClaimPrototypeGetCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardsClaimPrototypeGetCourierUserRewardsAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserRoleMappingsRaw(requestParameters: RewardsClaimPrototypeGetCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleMapping>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleMappingFromJSON));
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserRoleMappings(requestParameters: RewardsClaimPrototypeGetCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleMapping>> {
        const response = await this.rewardsClaimPrototypeGetCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roles of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeGetCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Role>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleFromJSON));
    }

    /**
     * Queries roles of CourierUser.
     */
    async rewardsClaimPrototypeGetCourierUserRoles(requestParameters: RewardsClaimPrototypeGetCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Role>> {
        const response = await this.rewardsClaimPrototypeGetCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation rewardPrize.
     */
    async rewardsClaimPrototypeGetRewardPrizeRaw(requestParameters: RewardsClaimPrototypeGetRewardPrizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardPrize>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetRewardPrize().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/rewardPrize`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardPrizeFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation rewardPrize.
     */
    async rewardsClaimPrototypeGetRewardPrize(requestParameters: RewardsClaimPrototypeGetRewardPrizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardPrize> {
        const response = await this.rewardsClaimPrototypeGetRewardPrizeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async rewardsClaimPrototypeGetRewardPrizeCourierRaw(requestParameters: RewardsClaimPrototypeGetRewardPrizeCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeGetRewardPrizeCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/rewardPrize/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async rewardsClaimPrototypeGetRewardPrizeCourier(requestParameters: RewardsClaimPrototypeGetRewardPrizeCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.rewardsClaimPrototypeGetRewardPrizeCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a related item by id for roles.
     */
    async rewardsClaimPrototypeLinkCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeLinkCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeLinkCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeLinkCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Add a related item by id for roles.
     */
    async rewardsClaimPrototypeLinkCourierUserRoles(requestParameters: RewardsClaimPrototypeLinkCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.rewardsClaimPrototypeLinkCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async rewardsClaimPrototypePatchAttributesRaw(requestParameters: RewardsClaimPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsClaimToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async rewardsClaimPrototypePatchAttributes(requestParameters: RewardsClaimPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async rewardsClaimPrototypeUnlinkCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeUnlinkCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUnlinkCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeUnlinkCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async rewardsClaimPrototypeUnlinkCourierUserRoles(requestParameters: RewardsClaimPrototypeUnlinkCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardsClaimPrototypeUnlinkCourierUserRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async rewardsClaimPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters: RewardsClaimPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async rewardsClaimPrototypeUpdateByIdCourierRewardsAccounts(requestParameters: RewardsClaimPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardsClaimPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserAccessTokensRaw(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserAccessTokens(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.rewardsClaimPrototypeUpdateByIdCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserCourierPackagesRaw(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserCourierPackages(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.rewardsClaimPrototypeUpdateByIdCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for invoices.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserInvoicesRaw(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for invoices.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserInvoices(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.rewardsClaimPrototypeUpdateByIdCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for mailboxes.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserMailboxesRaw(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for mailboxes.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserMailboxes(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.rewardsClaimPrototypeUpdateByIdCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for referrer.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserReferrerRaw(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for referrer.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserReferrer(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.rewardsClaimPrototypeUpdateByIdCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserRoleMappingsRaw(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserRoleMappings(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.rewardsClaimPrototypeUpdateByIdCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roles.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserRolesRaw(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardsClaimPrototypeUpdateByIdCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roles.
     */
    async rewardsClaimPrototypeUpdateByIdCourierUserRoles(requestParameters: RewardsClaimPrototypeUpdateByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.rewardsClaimPrototypeUpdateByIdCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update courierSetting of this model.
     */
    async rewardsClaimPrototypeUpdateCourierCourierSettingRaw(requestParameters: RewardsClaimPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Update courierSetting of this model.
     */
    async rewardsClaimPrototypeUpdateCourierCourierSetting(requestParameters: RewardsClaimPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.rewardsClaimPrototypeUpdateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update mailOption of this model.
     */
    async rewardsClaimPrototypeUpdateCourierMailOptionRaw(requestParameters: RewardsClaimPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Update mailOption of this model.
     */
    async rewardsClaimPrototypeUpdateCourierMailOption(requestParameters: RewardsClaimPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.rewardsClaimPrototypeUpdateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update rewardSetting of this model.
     */
    async rewardsClaimPrototypeUpdateCourierRewardSettingRaw(requestParameters: RewardsClaimPrototypeUpdateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Update rewardSetting of this model.
     */
    async rewardsClaimPrototypeUpdateCourierRewardSetting(requestParameters: RewardsClaimPrototypeUpdateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.rewardsClaimPrototypeUpdateCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update rewardsAccount of this model.
     */
    async rewardsClaimPrototypeUpdateCourierUserRewardsAccountRaw(requestParameters: RewardsClaimPrototypeUpdateCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimPrototypeUpdateCourierUserRewardsAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/courierUser/rewardsAccount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Update rewardsAccount of this model.
     */
    async rewardsClaimPrototypeUpdateCourierUserRewardsAccount(requestParameters: RewardsClaimPrototypeUpdateCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardsClaimPrototypeUpdateCourierUserRewardsAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async rewardsClaimReplaceByIdPostRewardsClaimsidReplaceRaw(requestParameters: RewardsClaimReplaceByIdPostRewardsClaimsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimReplaceByIdPostRewardsClaimsidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsClaimToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async rewardsClaimReplaceByIdPostRewardsClaimsidReplace(requestParameters: RewardsClaimReplaceByIdPostRewardsClaimsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimReplaceByIdPostRewardsClaimsidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async rewardsClaimReplaceByIdPutRewardsClaimsidRaw(requestParameters: RewardsClaimReplaceByIdPutRewardsClaimsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardsClaimReplaceByIdPutRewardsClaimsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsClaimToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async rewardsClaimReplaceByIdPutRewardsClaimsid(requestParameters: RewardsClaimReplaceByIdPutRewardsClaimsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimReplaceByIdPutRewardsClaimsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async rewardsClaimReplaceOrCreatePostRewardsClaimsReplaceOrCreateRaw(requestParameters: RewardsClaimReplaceOrCreatePostRewardsClaimsReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsClaimToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async rewardsClaimReplaceOrCreatePostRewardsClaimsReplaceOrCreate(requestParameters: RewardsClaimReplaceOrCreatePostRewardsClaimsReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimReplaceOrCreatePostRewardsClaimsReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async rewardsClaimReplaceOrCreatePutRewardsClaimsRaw(requestParameters: RewardsClaimReplaceOrCreatePutRewardsClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsClaimToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async rewardsClaimReplaceOrCreatePutRewardsClaims(requestParameters: RewardsClaimReplaceOrCreatePutRewardsClaimsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimReplaceOrCreatePutRewardsClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async rewardsClaimUpdateAllRaw(requestParameters: RewardsClaimUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsClaimToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async rewardsClaimUpdateAll(requestParameters: RewardsClaimUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.rewardsClaimUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async rewardsClaimUpsertWithWhereRaw(requestParameters: RewardsClaimUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsClaim>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardsClaims/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsClaimToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsClaimFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async rewardsClaimUpsertWithWhere(requestParameters: RewardsClaimUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsClaim> {
        const response = await this.rewardsClaimUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
